import { useState } from 'react'
import { Navigate } from 'react-router-dom'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useAttendanceDateNavigator } from '../lib/attendanceDateNavigatorContext'

const NavigateToPeriodPage = () => {
  const [path, setPath] = useState<string>()
  const { navigation } = useNavigation()
  const { resetAttendanceDateNavigator } = useAttendanceDateNavigator()

  useEffect(() => {
    if (!path) {
      const newDateNavigatorValue = resetAttendanceDateNavigator()
      const dateFrom = newDateNavigatorValue[0]
      const cycle = newDateNavigatorValue[2]

      setPath(
        navigation.clockIn.periodTypeYearMonthDay.fullPath({
          periodType: cycle,
          year: dateFrom.getFullYear(),
          month: dateFrom.getMonth() + 1,
          day: dateFrom.getDate(),
        })
      )
    }
  }, [path])

  if (path) return <Navigate replace to={path} />
}

export default NavigateToPeriodPage
